import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

import "./DarkMode.css";

const DarkMode = () => {
	const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
	const toggleTheme = () => {
		if (theme === "light") {
			setTheme("dark");
		} else {
			setTheme("light");
		}
	};
	useEffect(() => {
		localStorage.setItem("theme", theme);
		document.body.className = `${theme}-theme`;
	}, [theme]);
	return (
		<ul className="nav justify-content-end">
			<li className="nav-item">
				<Icon
					icon={theme === "dark" ? "ph:moon-stars-fill" : "ic:baseline-light-mode"}
					className="icon"
					onClick={toggleTheme}
				/>
			</li>
		</ul>
	);
};

export default DarkMode;
